import { render, staticRenderFns } from "./ModalLinkAccount.vue?vue&type=template&id=6aa3c6dc&scoped=true&"
import script from "./ModalLinkAccount.vue?vue&type=script&lang=js&"
export * from "./ModalLinkAccount.vue?vue&type=script&lang=js&"
import style0 from "./ModalLinkAccount.vue?vue&type=style&index=0&id=6aa3c6dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa3c6dc",
  null
  
)

export default component.exports